// extracted by mini-css-extract-plugin
export default {"logo":"NavLogo_logo__8wPya"};